export function latRad(lat) {
  const sin = Math.sin((lat * Math.PI) / 180);
  const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
  return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
}

export function zoom(mapPx, worldPx, fraction) {
  return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
}

export const fixedNumber = (n, digit) => {
  return Number(parseFloat(n).toFixed(digit));
}

export const beautifyPrice = (n) => {
  const price = parseInt(n).toString();
  const stringPrice = n.toString();
  if(price.length > 3) {
    return `${price.slice(0, price.length-3)},${stringPrice.slice(price.length-3)}`
  }
  return n;
}

export const getDistance = (lat1, lon1, lat2, lon2) => {
  var dLat = degreesToRadians(lat2 - lat1);
  var dLon = degreesToRadians(lon2 - lon1);
  var a =
      Math.sin(dLat/2)*Math.sin(dLat/2) +
      Math.cos(degreesToRadians(lat1))*Math.cos(degreesToRadians(lat2))*Math.sin(dLon/2) * Math.sin(dLon/2);
  var c = 2*Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = 6378.1 * c;
  return d * 1000;
}

const degreesToRadians = (degrees) =>  {
  const degToRadFactor = Math.PI / 180;
  return degrees * degToRadFactor;
}